import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/SolutionsDataPipelinePlatformPage.head';
import { SolutionsDataPipelinePlatformPage } from '@pages/SolutionsDataPipelinePlatformPage';

export const Route = createFileRoute('/solutions/data-pipeline-platform')({
  component: SolutionsDataPipelinePlatformPage,
  head: () => head,
});
